import React, { useContext, useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { CredsContext } from "./Contexts";
import { DataManager, Query } from "@syncfusion/ej2-data";
import "./styles/GanttChartComponent.css";
import {
  GanttComponent,
  Inject,
  Toolbar,
  ColumnsDirective,
  ColumnDirective,
  Edit,
  Selection,
  Resize,
  PdfExport,
  EditDialogFieldsDirective,
  EditDialogFieldDirective,
  AddDialogFieldsDirective,
  AddDialogFieldDirective,
  Sort,
  RowDD,
} from "@syncfusion/ej2-react-gantt";
import Box from "@mui/material/Box";
//import Tour from "./Tour";
import Typography from "@mui/material/Typography";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import CustomAlert from "./CustomAlert";
import ProjectTitleBar from "./ProjectTitleBar_ably";
import AnalysisContainerAsFooter from "./AnalysisContainerAsFooter v2";

function GanttChartComponent(props) {
  const creds = useContext(CredsContext).creds;
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const [showAlerts, setShowAlerts] = useState(true);
  const [showBaseline, setShowBaseline] = useState(false);
  const analysisTaskIdSelected = useRef();
  const analysisTaskIdUnselected = useRef();
  const ROW_HIGHLIGHT_COLOR = "#FFFF55";
  let ganttInstance;

  const commitEnabled = useRef(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openEditingNotification, setOpenEditingNotification] = useState(false);
  const tasksAdded = useRef(0);
  const oadaSettings = JSON.parse(localStorage.getItem("oadaSettings"));
  const zoomLevel = useRef(0);
  const TOUR_ID = "Gantt";
  const initialTourState = {
    key: new Date(),
    run: false,
    loading: false,
    stepIndex: 0,
    steps: [
      {
        target: ".e-toolbar-left",
        content: (
          <Box>
            <p>
              These tools provide features and functionality for the Gantt
              Chart. Note that the &quot;Save&quot; button will become enabled
              when a change has been made to a task on the Gantt Chart.
            </p>
          </Box>
        ),
        disableBeacon: true,
      },
      {
        target: ".e-toolbar-right",
        content: (
          <Box>
            <p>
              This indicates if the dates on the Gantt Chart are coming from
              Task Assignments or Bookings
            </p>
          </Box>
        ),
      },
      {
        target: ".tour-stop-3",
        content: (
          <Box>
            <p>
              These Task Alerts help identify noteworthy task conditions. The
              project team should be aware of these tasks&apos; status and be
              prepared to mitigate any schedule or budget issues due to these
              variances.
            </p>
          </Box>
        ),
      },
    ],
  };

  function toolbarClick(args) {
    if (args.item.id === "Refresh") {
      disableCommit();
      props.handleRefresh();
    }
    if (args.item.id === "Commit") {
      disableCommit();
      props.commitChanges();
      //setOpenConfirmation(true);  no longer using, may restore
    }
    if (args.item.text === "Pdf export") {
      var exportProperties = {
        fitToWidthSettings: {
          isFitToWidth: true,
          gridWidth: "50%,",
        },
      };
      ganttInstance.pdfExport(exportProperties);
    }
    if (args.item.id == "Alerts") {
      setShowAlerts(!showAlerts);
    }
    if (args.item.id == "Baseline") {
      setShowBaseline(!showBaseline);
    }
    if (args.item.id == "Delete") {
      ganttInstance.editModule.deleteRow();
    }
    if (args.item.id == "ZoomIn") {
      ganttInstance.zoomIn();
    }
    if (args.item.id == "ZoomOut") {
      ganttInstance.zoomOut();
    }
    if (args.item.id == "ZoomToFit") {
      ganttInstance.fitToProject();
    }
    if (args.item.id == "SaveBaseline") {
      props.saveBaseline();
    }
  }

  useEffect(() => {
    if (!commitEnabled.current) {
      disableCommit();
    }

    const toolbarButtons = document.getElementsByClassName("e-tbar-btn-text");
    if (toolbarButtons.length > 0) {
      for (let elem of toolbarButtons) {
        if (elem.textContent == "Pdf export") {
          elem.textContent = "PDF export";
        }
      }
    }

    if (ganttInstance) {
      ganttInstance.fitToProject();
    }
  });

  /*
  // Intended to default view to fitToProject, does not have desired effect
  useEffect(() => {
    if (ganttInstance) {
      ganttInstance.fitToProject();
    }
  }, [ganttInstance]);*/

  function onActionBegin(args) {
    if (args.requestType == "beforeOpenEditDialog") {
      if (
        //args.rowData.resources.indexOf(props.userFullName) == -1 &&
        !args.rowData.taskData.CurrentUserAssigned &&
        creds.projectRole != "F"
      ) {
        args.dialogModel.buttons.shift();
        const verbToUse =
          oadaSettings.ganttDateSource == "bookings" ? "booked" : "assigned";
        args.dialogModel.header =
          "You must be " + verbToUse + " to the task in order to edit it";
      }
    }
  }

  function queryTaskbarInfo(args) {
    if (args.taskbarType == "ParentTask") {
      args.taskbarBgColor = "lightgray";
      args.progressBarBgColor = "lightslategray";
      args.taskbarElement.className += " e-preventEdit";
    } else if (args.taskbarType == "ChildTask") {
      args.taskbarBgColor = "lightblue";
      args.progressBarBgColor = "dodgerblue";
    }

    if (creds.projectRole != "F") {
      //if (args.data.resources.indexOf(props.userFullName) > -1) {
      if (args.data.taskData.CurrentUserAssigned) {
        //args.rightLabelColor = "red";
        args.rowElement.bgColor = "#E2FFE2";
      } else {
        args.taskbarElement.className += " e-preventEdit";
      }
    }

    if (args.data.taskData.TaskID == analysisTaskIdSelected.current) {
      args.rowElement.bgColor = ROW_HIGHLIGHT_COLOR;
    }
    if (args.data.taskData.TaskID == analysisTaskIdUnselected.current) {
      args.rowElement.bgColor = "white";
    }

    /*    if (!oadaSettings.ganttDateEditing) {
      args.taskbarElement.className += " e-preventEdit";
    }*/
  }

  function taskbarEditing(args) {
    if (args.taskBarEditAction == "ParentDrag") {
      args.cancel = true;
    }

    if (creds.projectRole != "F") {
      //if (args.data.resources.indexOf(props.userFullName) == -1) {
      if (!args.data.taskData.CurrentUserAssigned) {
        args.cancel = true;
      }
    }
    if (
      !oadaSettings.ganttDateEditing &&
      args.taskBarEditAction != "ProgressResizing"
    ) {
      args.cancel = true;
      setOpenEditingNotification(true);
    }
  }

  function disableCommit() {
    if (ganttInstance) {
      //ganttInstance.fitToProject = true;
      ganttInstance.toolbarModule.enableItems(["Commit"], false);
      commitEnabled.current = false;
    }
  }

  function rowDataBound(args) {
    if (args.data.TaskID == analysisTaskIdSelected.current) {
      args.row.style.backgroundColor = ROW_HIGHLIGHT_COLOR;
    }
    if (args.data.TaskID == analysisTaskIdUnselected.current) {
      args.row.style.backgroundColor = "white";
    }
  }

  function beforeExport() {
    // trying to remove columns from PDF, doesn't seem to do anything...
    if (ganttInstance) {
      ganttInstance.columns[6].visible = false;
      ganttInstance.columns[7].visible = false;
    }
  }
  if (props.tasks.length > 0) {
    const taskFields = {
      id: "TaskID",
      name: "TaskName",
      startDate: "StartDate",
      endDate: "EndDate",
      duration: "Duration",
      progress: "Progress",
      parentID: "ParentID",
      dependency: "Predecessor",
      resourceInfo: "resources",
      baselineStartDate: "BaselineStartDate",
      baselineEndDate: "BaselineEndDate",
      notes: "Notes",
      manual: "Manual", // was Manual until 2/5/2025, then Auto, even though that doesn't have any meaning.
      work: "Work",
      //taskType: "TaskType",
    };

    let dateSource =
      oadaSettings.ganttDateSource == "bookings"
        ? "Dates from Bookings"
        : "Dates from Task Assignments";
    let toolbarOptions = [
      {
        text: "&nbsp;&nbsp;Save&nbsp;&nbsp;",
        tooltipText: "Commit",
        id: "Commit",
        prefixIcon: "e-save-2",
        color: "green",
        width: "150px",
      },
      "Add",
      {
        text: "Delete",
        tooltipText: "Delete Task",
        id: "Delete",
        prefixIcon: "e-delete-1",
      },

      {
        text: "",
        tooltipText: "Zoom In",
        id: "ZoomIn",
        prefixIcon: "e-zoom-in",
        color: "black",
      },
      {
        text: "",
        tooltipText: "Zoom Out",
        id: "ZoomOut",
        prefixIcon: "e-zoom-out",
        color: "black",
      },
      /*{
    text: "",
    tooltipText: "Zoom To Fit",
    id: "ZoomToFit",
    prefixIcon: "e-zoom-to-fit",
    color: "black",
  },*/
      //"ZoomIn",
      //"ZoomOut",
      "ZoomToFit",

      {
        text: showAlerts ? "Hide Alerts" : "Show Alerts",
        tooltipText: "Alerts",
        id: "Alerts",
        prefixIcon: "e-warning",
        color: "black",
      },

      "PdfExport",
      {
        text: "Refresh",
        tooltipText: "Refresh",
        id: "Refresh",
        prefixIcon: "e-repeat",
      }, // check index.html to see where icon came from
      {
        text: "Show Baseline",
        tooltipText: "Baseline",
        id: "Baseline",
        prefixIcon: "e-justify",
        color: "black",
      },
      {
        text: "Save Baseline",
        tooltipText: "Save Baseline",
        id: "SaveBaseline",
        prefixIcon: "e-date-range",
        color: "black",
      },
      "Indent",
      "Outdent",
      {
        color: "lightblue",
        align: "right",
        text: "<b>" + dateSource + "</b>",
        disabled: true,
      },
    ];

    const timelineSettings = {
      timelineViewMode: "Month",
    };
    const labelSettings = {
      rightLabel: "resources",
    };

    const resourceFields = {
      id: "resourceId",
      name: "resourceName",
      unit: "Unit",
    };

    const splitterPct = localStorage.getItem("splitterPct");
    const splitterSettings = splitterPct
      ? { position: splitterPct }
      : { columnIndex: 5 };
    const editOptions = {
      allowTaskbarEditing: true,
      allowEditing: true,
      allowAdding: true,
      allowDeleting: true,
      newRowPosition: "Top",
      mode: "Dialog",
    };

    const handleActionComplete = (event) => {
      if (
        (event.action == "DialogEditing" ||
          event.action == "DrawConnectorLine" ||
          event.action == "add" ||
          event.action == "delete" ||
          event.requestType == "indented" ||
          event.requestType == "outdented" ||
          event.requestType == "rowDropped" ||
          (event.action == "TaskbarEditing" && oadaSettings.ganttDateEditing) ||
          event.taskBarEditAction == "ProgressResizing") &&
        event.taskBarEditAction != "ParentDrag"
      ) {
        ganttInstance.toolbarModule.enableItems(["Commit"], true); // enable toolbar items.
        commitEnabled.current = true;
      }

      if (event.requestType == "AfterZoomOut") {
        zoomLevel.current--;
        if (zoomLevel.current == -6) {
          ganttInstance.toolbarModule.enableItems(["ZoomOut"], false);
        } else {
          ganttInstance.toolbarModule.enableItems(["ZoomIn"], true);
        }
      }

      if (event.requestType == "AfterZoomIn") {
        zoomLevel.current++;
        if (zoomLevel.current == 12) {
          ganttInstance.toolbarModule.enableItems(["ZoomIn"], false);
        } else {
          ganttInstance.toolbarModule.enableItems(["ZoomOut"], true);
        }
      }

      if (event.requestType == "AfterZoomToProject") {
        zoomLevel.current = 0;
        ganttInstance.toolbarModule.enableItems(["ZoomIn"], true);
        ganttInstance.toolbarModule.enableItems(["ZoomOut"], true);
      }
      props.handleActionComplete(event);
      if (event.action == "add") {
        const parentId = event.data.ParentID;
        if (parentId) {
          const placementIndex = ganttInstance.currentViewData.findIndex(
            (elem) => elem.TaskID == parentId,
          );
          ganttInstance.reorderRows(
            [0],
            placementIndex - tasksAdded.current,
            "child",
          );
          tasksAdded.current++;
        }
      }
    };

    const handleAnalysisRowClick = (taskid) => {
      // this probably could be done easier but this works
      if (analysisTaskIdSelected.current != parseInt(taskid)) {
        analysisTaskIdUnselected.current = analysisTaskIdSelected.current;
        ganttInstance.updateRecordByID({
          TaskID: analysisTaskIdUnselected.current,
        });
        analysisTaskIdSelected.current = parseInt(taskid);
        ganttInstance.updateRecordByID({
          TaskID: analysisTaskIdSelected.current,
        });
      } else {
        analysisTaskIdUnselected.current = parseInt(taskid);
        analysisTaskIdSelected.current = 0;
        ganttInstance.updateRecordByID({
          TaskID: analysisTaskIdUnselected.current,
        });
      }
    };

    const handleNotificationClose = (event, reason) => {
      if (reason === "clickaway") {
        return;
      }
      setOpenEditingNotification(false);
    };

    const sortOptions = {
      columns: [{ field: "StartDate", direction: "Ascending" }],
    };

    const phases = [];
    props.tasks.forEach((elem) => {
      if (elem.IsAPhase == 1) {
        phases.push({ phaseName: elem.TaskName, phaseId: elem.TaskID });
      }
    });

    const phaseParams = {
      params: {
        actionComplete: () => false,
        allowFiltering: true,
        dataSource: new DataManager(phases),
        fields: { text: "phaseName", value: "phaseId" },
        query: new Query(),
      },
    };

    /*const nameTemplate = (record) => {
      let returnVal = {record.TaskName};
      if (record.TaskName == "New Task 28") {
        returnVal = <div textDecoration="line-through">{record.TaskName}</div>;
      }
      return returnVal;
    };*/

    const hoursTemplate = (record) => {
      return <div>{parseInt(record.Work * 4) / 4}</div>;
    };

    const taskNameTemplate = (record) => {
      return <div className="ganttTaskName">{record.TaskName}</div>;
    };

    const addAdditionalParams = {
      inlineMode: { enable: true, onSelection: true },
    };
    const editAdditionalParams = {
      inlineMode: { enable: true, onSelection: true },
    };

    const splitterResized = (event) => {
      const p0 = event.paneSize[0];
      const p1 = event.paneSize[1];
      const pct = parseInt((p0 / (p0 + p1)) * 100);

      localStorage.setItem("splitterPct", pct + "%");
      console.log("pct: " + pct);
    };
    //}
    //if (props.tasks.length >=0) {
    return (
      <>
        {/*<Tour initialState={initialTourState} id={TOUR_ID} />*/}
        <CustomAlert
          alertText="Commit Successful"
          openAlert={openConfirmation}
          setOpenAlert={setOpenConfirmation}
        />
        <Box>
          <Box
            sx={{
              height: showAlerts ? "70vh" : "90vh",
            }}
          >
            <ProjectTitleBar
              aiData={props.tasks}
              aiDataType="tasks"
              top={48}
              docPage="GANTT+CHART TAB.pdf"
            />
            <br></br>
            <br></br>

            <GanttComponent
              actionBegin={onActionBegin}
              actionComplete={handleActionComplete}
              allowPdfExport={true}
              allowResizing={true}
              allowRowDragAndDrop={true}
              allowSorting={true}
              beforePdfExport={beforeExport}
              created={disableCommit}
              dataSource={props.tasks}
              editSettings={editOptions}
              //enableImmutableMode={true}
              height="100%"
              includeWeekend={projectObject.oada_project_weekends__c == "1"}
              labelSettings={labelSettings}
              queryTaskbarInfo={queryTaskbarInfo}
              ref={(gantt) => (ganttInstance = gantt)}
              renderBaseline={showBaseline}
              resourceFields={resourceFields}
              resources={props.resources}
              rowDataBound={rowDataBound}
              rowHeight={25}
              sortSettings={sortOptions}
              splitterResized={splitterResized}
              splitterSettings={splitterSettings}
              sx={{ zIndex: 1 }}
              taskbarEdited={handleActionComplete}
              taskbarEditing={taskbarEditing}
              taskFields={taskFields}
              taskMode="Custom"
              timelineSettings={timelineSettings}
              toolbar={toolbarOptions}
              toolbarClick={toolbarClick}
              treeColumnIndex={0}
              width="100%"
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="TaskName"
                  customAttributes={{ class: "ganttPointerCursor" }}
                  minWidth="200"
                  width="200"
                  maxWidth="400"
                  textAlign="Left"
                ></ColumnDirective>
                <ColumnDirective
                  field="StartDate"
                  minWidth="100"
                  width="120"
                  maxWidth="130"
                  headerTextAlign="Center"
                ></ColumnDirective>
                <ColumnDirective
                  field="EndDate"
                  minWidth="100"
                  width="120"
                  maxWidth="130"
                  headerTextAlign="Center"
                ></ColumnDirective>
                <ColumnDirective
                  field="Progress"
                  width="80"
                  headerText="%"
                ></ColumnDirective>
                <ColumnDirective
                  field="Work"
                  width="80"
                  headerText="Work"
                  template={hoursTemplate}
                  allowEditing={true}
                ></ColumnDirective>
                <ColumnDirective
                  field="resources"
                  minWidth="100"
                  width="300"
                  maxWidth="500"
                  textAlign="Left"
                  visible={false}
                  allowEditing={true}
                ></ColumnDirective>
                <ColumnDirective
                  field="ParentID"
                  //editType="dropdownedit"
                  //edit={phaseParams}
                  minWidth="100"
                  width="125"
                  maxWidth="150"
                  textAlign="Left"
                  visible={false}
                  allowEditing={false}
                ></ColumnDirective>

                <ColumnDirective
                  field="Duration"
                  minWidth="100"
                  width="125"
                  maxWidth="150"
                  textAlign="Left"
                  visible={true}
                  allowEditing={true}
                ></ColumnDirective>

                <ColumnDirective
                  field="TaskID"
                  minWidth="100"
                  width="125"
                  maxWidth="150"
                  textAlign="Left"
                  isPrimaryKey={true}
                  visible={true}
                  allowEditing={false}
                ></ColumnDirective>
              </ColumnsDirective>
              {oadaSettings.ganttDateEditing ? (
                <AddDialogFieldsDirective>
                  <AddDialogFieldDirective
                    type="General"
                    headerText="General"
                    fields={[
                      "ParentID",
                      "TaskName",
                      "StartDate",
                      "EndDate",
                      "Work",
                      "Progress",
                    ]}
                  ></AddDialogFieldDirective>
                  <AddDialogFieldDirective type="Dependency"></AddDialogFieldDirective>
                  <AddDialogFieldDirective type="Resources"></AddDialogFieldDirective>
                </AddDialogFieldsDirective>
              ) : (
                <AddDialogFieldsDirective>
                  <AddDialogFieldDirective
                    type="General"
                    headerText="General"
                    fields={["ParentID", "TaskName", "Work", "Progress"]}
                  ></AddDialogFieldDirective>
                  <AddDialogFieldDirective type="Dependency"></AddDialogFieldDirective>
                  <AddDialogFieldDirective type="Resources"></AddDialogFieldDirective>
                </AddDialogFieldsDirective>
              )}
              {oadaSettings.ganttDateEditing ? (
                <EditDialogFieldsDirective>
                  <EditDialogFieldDirective
                    type="General"
                    headerText="General"
                    fields={[
                      "ParentID",
                      "TaskName",
                      "StartDate",
                      "EndDate",
                      "Work",
                      "Progress",
                      "Duration",
                    ]}
                  ></EditDialogFieldDirective>
                  <EditDialogFieldDirective type="Dependency"></EditDialogFieldDirective>
                  <EditDialogFieldDirective
                    type="Resources"
                    headerText="Resources"
                  ></EditDialogFieldDirective>
                </EditDialogFieldsDirective>
              ) : (
                <EditDialogFieldsDirective>
                  <EditDialogFieldDirective
                    type="General"
                    headerText="General"
                    fields={[
                      "ParentID",
                      "TaskName",
                      "Work",
                      "Progress",
                      "Duration",
                    ]}
                  ></EditDialogFieldDirective>
                  <EditDialogFieldDirective type="Dependency"></EditDialogFieldDirective>
                  <EditDialogFieldDirective type="Resources"></EditDialogFieldDirective>
                </EditDialogFieldsDirective>
              )}
              <Inject
                services={[
                  Toolbar,
                  Edit,
                  Selection,
                  Resize,
                  PdfExport,
                  Sort,
                  RowDD,
                ]}
              />
            </GanttComponent>
          </Box>
          {showAlerts ? (
            <Box
              sx={{
                height: "20vh",
                overflowY: "scroll",
                position: "fixed",
                bottom: 0,
                width: "100%",
                zIndex: 998,
              }}
            >
              <AnalysisContainerAsFooter
                className="tour-stop-3"
                projectid={projectObject.id}
                projectname={projectObject.name}
                handleAnalysisRowClick={handleAnalysisRowClick}
                waitHandler={props.waitHandler}
              />
            </Box>
          ) : (
            <></>
          )}
        </Box>
        <Snackbar
          open={openEditingNotification}
          autoHideDuration={5000}
          onClose={handleNotificationClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            variant="filled"
            onClose={handleNotificationClose}
            severity="warning"
            sx={{ width: "100%", fontSize: "large" }}
          >
            Date editing is disabled for the Gantt Chart. To edit the Percent
            Complete or Planned Hours, double-click the task name.
          </Alert>
        </Snackbar>
      </>
    );
  } else if (!props.waitValue) {
    return (
      <Box>
        <Box
          sx={{
            height: showAlerts ? "70vh" : "90vh",
          }}
        >
          <ProjectTitleBar
            aiData={props.tasks}
            aiDataType="tasks"
            top={48}
            docPage="GANTT+CHART TAB.pdf"
          />
          <br></br>
          <br></br>
          <Typography
            variant="h5"
            sx={{
              padding: "20px",
              backgroundColor: "lightyellow",
              fontWeight: "bold",
            }}
          >
            No tasks found -- tasks must be added in OpenAir
          </Typography>
        </Box>
      </Box>
    );
  }
}
export default GanttChartComponent;

GanttChartComponent.propTypes = {
  tasks: PropTypes.array,
  resources: PropTypes.array,
  //userFullName: PropTypes.string,
  handleRefresh: PropTypes.func,
  handleActionComplete: PropTypes.func,
  commitChanges: PropTypes.func,
  waitHandler: PropTypes.func,
  waitValue: PropTypes.bool,
  saveBaseline: PropTypes.func,
};
